<script lang="ts">
  export let text: string;
</script>

<div class="p-2 bg-Purple700 {$$props.class}">
  <span class="text-white font-bold text-sm">{text}</span>
</div>
